module.exports = __webpack_public_path__ + "img/logoadminsmall.d0b7b0be.png";